import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Box } from '@mui/material';


const ResponseCodeStatus = ({ responseStatusCodes }) => {
    if (!responseStatusCodes || responseStatusCodes.length === 0) {
        return <div>No status code data available</div>;
    }

    const formattedData = responseStatusCodes.map((item) => ({
        id: String(item.statusCode),
        value: item.percentage,
        label: `Status ${item.statusCode}`,
    }));

    const size = {
        width: 400,
        height: 450,
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <PieChart
                series={[
                    {
                        arcLabel: (item) => `${item.value}%`,
                        arcLabelMinAngle: 10,
                        arcLabelRadius: '60%',
                        data: formattedData,
                    },
                ]}
                slotProps={{
                    legend: {
                        direction: 'row',
                        position: { vertical: 'bottom', horizontal: 'center' },

                    },
                }}
                sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                        fontWeight: 'bold',
                    },
                    mt: 3, // space above chart
                    mb: 2, // space below chart
                }}
                {...size}
            />
        </Box>
    );
};

export default ResponseCodeStatus;
